import React, { PropsWithChildren } from 'react';
import { Stack } from '@mui/material';

interface Props {
  side: 'left' | 'right';
}

export function FloatingOverSceneColumn({ side, children }: PropsWithChildren<Props>) {
  return (
    <Stack
      spacing={1}
      sx={[
        {
          alignItems: side === 'left' ? 'flex-start' : 'flex-end',
          position: 'absolute',
          top: (theme) => theme.spacing(1),
          bottom: (theme) => theme.spacing(1),
          zIndex: (theme) => theme.zIndex.drawer - 1,

          pointerEvents: 'none',
          '& *': { pointerEvents: 'auto' },
        },
        (theme) => ({
          [side]: theme.spacing(1),
          transition: theme.transitions.create(side, {
            easing: theme.transitions.easing.easeOut,
            duration: 100,
          }),
        }),
      ]}
    >
      {children}
    </Stack>
  );
}
